import { Prismic } from '@landsbankinn/prismic';
import React from 'react';
import { SmartBookingCustomerType } from '../../__generated__/globalTypes';
import { BookAppointment } from '../components/book-appointment/BookAppointment';

interface IProps {
  type?: 'Company' | 'Person';
  default_corporate_service?: string;
  default_personal_service?: string;
  image: Prismic.Image;
  title: Prismic.RichText;
  copy: Prismic.RichText;
}

export function BookAppointmentContainer({
  type,
  default_corporate_service,
  default_personal_service,
  image,
  title,
  copy,
}: IProps) {
  const defaultServiceId =
    default_personal_service?.match(/:(.*)/)?.[1] ??
    default_corporate_service?.match(/:(.*)/)?.[1];

  const getDefaultCustomerType = () => {
    if (type === 'Company' || default_corporate_service) {
      return SmartBookingCustomerType.Company;
    } else if (type === 'Person' || default_personal_service) {
      return SmartBookingCustomerType.Person;
    }
  };
  const _title = Prismic.text(title);
  const _copy = Prismic.text(copy);

  return (
    <BookAppointment
      image={image}
      defaultServiceId={defaultServiceId}
      defaultCustomerType={getDefaultCustomerType()}
      title={_title !== null ? _title : ''}
      copy={_copy !== null ? _copy : ''}
    />
  );
}
